import { useState } from "react";
import { Beer } from "../../../data/types";
import "./AddBeer.scss";
import { addBeer } from "../../../services/firestore";

const AddBeer = () => {
  const [beer, setBeer] = useState<Beer>({
    name: "",
    abv: "",
    type: "",
    image: "",
    id: "",
    availability: "",
    untappdLink: "",
    order: 1000,
    available: true,
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setBeer((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();

    if (beer.name && beer.abv /* && beer.image */ && beer.type) {
      addBeer(beer);
      setBeer({
        name: "",
        abv: "",
        type: "",
        image: "",
        id: "",
        availability: "",
        untappdLink: "",
        order: 1000,
      });
    }
  };

  return (
    <form action="" className="add-beer">
      <input
        type="text"
        name="name"
        placeholder="Name"
        value={beer.name || ""}
        onChange={handleChange}
      />
      <input
        type="text"
        name="abv"
        placeholder="Abv"
        value={beer.abv || ""}
        onChange={handleChange}
      />
      <input
        type="text"
        name="type"
        placeholder="Beer type"
        value={beer.type || ""}
        onChange={handleChange}
      />
      <input
        type="text"
        name="untappdLink"
        placeholder="Untappd link"
        value={beer.untappdLink || ""}
        onChange={handleChange}
      />
      <input
        type="text"
        name="image"
        placeholder="Image"
        value={beer.image || ""}
        onChange={handleChange}
      />
      <input
        type="text"
        name="availability"
        placeholder="Available at"
        value={beer.availability || ""}
        onChange={handleChange}
      />

      <textarea
        name="description"
        value={beer.description || ""}
        onChange={handleChange}
        placeholder="Description"
      />

      <textarea
        name="funFact"
        value={beer.funFact || ""}
        onChange={handleChange}
        placeholder="Fun fact"
      />

      <button onClick={handleAdd}>Add</button>
    </form>
  );
};

export default AddBeer;
